import { HttpClient,HttpHeaders,HttpBackend  } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserProfile } from '../model/user-profile';
import { EnvService } from '../core/env.service';
import { map } from 'rxjs/operators'
import { CookieService } from 'ngx-cookie';

@Injectable()
export class AppService {
    userProfile: UserProfile;

    constructor(private _httpClient: HttpClient,public _env: EnvService,
        private _handler: HttpBackend, private _httpClientWithToken: HttpClient, 
        private _cookieService: CookieService) {
            this._httpClient = new HttpClient(this._handler);   //this will not be intercepted by our service auth-interceptor
     }

    getBySessionId(): Observable<any>{
        let token =  this._cookieService.get('_access_token'); 
        if(token !== undefined){//if we already have the token then we don't need to cookie anymore
            const headers = new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
              })
            return this._httpClient.get<any>(this._env.apictgf + 'User/GetNewToken',{ headers: headers })
            .pipe(map((res: any) => res));
        }else{
            return this._httpClient.get<any>(this._env.apictgf + 'User/CheckLoginBySessionId',{withCredentials: true})//with credential will sent the cookie to backend
            .pipe(map((res: any) => res));
        }
    }

    HasCtDashboardAccess():Observable<boolean>{
        return this._httpClient.get<any>(this._env.apictgf + 'User/HasCtDashboardAccess',{withCredentials: true})//with credential will sent the cookie to backend
        .pipe(map((res: any) => res));
    }

    getCurrency(): Observable<Array<any>> {
        return this._httpClientWithToken.get<Array<any>>(this._env.apictgf +'CT/GetCurrency')
        .pipe(map((res: Array<any>) => res));
    }

    GetInvoiceStatus():any {
        return this._httpClientWithToken.get<any>(this._env.apictgf + 'CT/GetInvoiceStatus')
        .pipe(map((res: any) => res));
    }

    getClients(): Observable<any>{
        return this._httpClientWithToken.get<any[]>(this._env.apictgf + 'CT/GetClients')
        .pipe(map((res: any[]) =>res));
    }

    getAllocation(invoiceId: Number){
        return this._httpClientWithToken.get<Array<any>>(this._env.apictgf +'CT/GetAllocation?invoiceId='+ invoiceId)
        .pipe(map((res: any) => res));
    }
    
    GetCountriesList(): Observable<any>{
        return this._httpClientWithToken.get<any[]>(this._env.apictgf + 'CT/GetCountries', { 
        }).pipe(map((res: any[]) => res));
    }
}